var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo flex items-center cursor-pointer",on:{"click":_vm.backHome}},[_c('img',{staticClass:"img",attrs:{"src":require("@/render/assets/images/header/logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }